import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  permissions:
    localStorage.getItem("permissions") !== null
      ? JSON.parse(localStorage.getItem("permissions"))
      : {},
};

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions: (state, action) => {
      state.permissions = action.payload;
      localStorage.setItem("permissions", JSON.stringify(action.payload));
    },
    clearPermissions: (state) => {
      state.permissions = {};
      localStorage.removeItem("permissions");
    },
  },
});

export const { setPermissions, clearPermissions } = permissionsSlice.actions;

export const selectPermissions = (state) => state.permissions.permissions;

export default permissionsSlice.reducer;
